<template>
  <div>
    <el-table :data="records">
      <el-table-column label="时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime | moment }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="cloudMiningId" label="项目ID"> </el-table-column>
      <el-table-column prop="userid" label="用户ID"> </el-table-column>
      <el-table-column label="支付金额">
        <template slot-scope="scope">
          {{ scope.row.payAmount }} {{ scope.row.payCoinType }}
        </template>
      </el-table-column>
      <el-table-column  label="购买金额">
        <template slot-scope="scope">
          {{ scope.row.distributionCoinAmount }} {{ scope.row.distributionCoinType }}
        </template>
      </el-table-column>
      <el-table-column
        prop="day"
        label="周期"
      ></el-table-column>
      <el-table-column label="开始挖矿时间">
           <template slot-scope="scope">
          <span>{{ scope.row.miningStartTime | moment }}</span>
        </template>
      </el-table-column>    
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'miningRecord',
  computed: {
    ...mapState('miningRecord', [
      'totalCount',
      'pagination',
      'rata',
      'records'
    ])
  },
  components: {
    Pagination
  },
  methods: {
    ...mapActions('miningRecord', ['getRecords']),
    handleCurrentChange(pagination) {
      this.$emit('refresh', pagination);
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped></style>
